import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { LocationOn } from '@mui/icons-material';

interface ProfilePreferredLocationsProps {
  locations?: string[];
}

export default function ProfilePreferredLocations({ locations }: ProfilePreferredLocationsProps) {
  if (!locations || locations.length === 0) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Preferred Work Locations
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={1}>
          {locations.map((location: string, index: number) => (
            <Chip
              key={index}
              icon={<LocationOn />}
              label={location}
              variant="outlined"
              color="info"
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}